/* ==========================================================================
   Go Damn — Before & After slider   [data-gdh-ba]
   Used by sections/gd-proof ("Results + stats").
   - drag the handle with mouse, touch or pen
   - click / tap anywhere on the photo to glide the handle there
   - arrow keys, Page Up/Down, Home/End on the focused handle
   The handle eases toward its target for a smooth feel; with reduced
   motion it moves instantly. Vertical swipes on phones still scroll the page.
   ========================================================================== */
(function () {
  'use strict';
  if (window.gdhCompare) { window.gdhCompare(document); return; }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function clamp(v) { return Math.max(0, Math.min(100, v)); }

  function bind(root) {
    if (root.hasAttribute('data-gdh-ba-bound')) return;
    root.setAttribute('data-gdh-ba-bound', '');

    var knob = root.querySelector('[data-gdh-ba-knob]');
    var beforeL = root.getAttribute('data-before') || 'Before';
    var afterL = root.getAttribute('data-after') || 'After';
    var start = parseFloat(root.getAttribute('data-start'));
    start = isNaN(start) ? 50 : clamp(start);

    var target = start, current = start, speed = 0.2, raf = 0, shown = -1;
    var drag = null, used = false;

    function paint() {
      root.style.setProperty('--gdh-ba-pos', current.toFixed(2) + '%');
      root.classList.toggle('is-hide-before', current < 16);
      root.classList.toggle('is-hide-after', current > 84);
      var v = Math.round(current);
      if (knob && v !== shown) {
        shown = v;
        knob.setAttribute('aria-valuenow', v);
        knob.setAttribute('aria-valuetext', beforeL + ' ' + v + '%, ' + afterL + ' ' + (100 - v) + '%');
      }
    }

    function tick() {
      raf = 0;
      var d = target - current;
      current = (reduce || Math.abs(d) < 0.05) ? target : current + d * speed;
      paint();
      if (current !== target) raf = requestAnimationFrame(tick);
    }

    function moveTo(p, s) {
      target = clamp(p);
      speed = s;
      if (!raf) raf = requestAnimationFrame(tick);
    }

    function pct(x) {
      var r = root.getBoundingClientRect();
      return r.width ? (x - r.left) / r.width * 100 : target;
    }

    function begin(e) {
      drag.active = true;
      root.classList.add('is-dragging');
      try { root.setPointerCapture(e.pointerId); } catch (err) {}
    }

    function finish(e) {
      if (!drag || e.pointerId !== drag.id) return;
      if (!drag.active && e.type === 'pointerup') moveTo(pct(e.clientX), 0.2); /* tap = glide there */
      drag = null;
      root.classList.remove('is-dragging');
    }

    root.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      used = true;
      var onKnob = !!(knob && knob.contains(e.target));
      drag = {
        id: e.pointerId, x: e.clientX, y: e.clientY, active: false,
        offset: onKnob ? pct(e.clientX) - current : 0
      };
      /* mouse and the handle itself start dragging at once; a finger on the
         photo waits to see if it moves sideways (drag) or up/down (scroll) */
      if (onKnob || e.pointerType === 'mouse') {
        begin(e);
        if (!onKnob) moveTo(pct(e.clientX), 0.22);
      }
    });

    root.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      if (!drag.active) {
        var dx = Math.abs(e.clientX - drag.x), dy = Math.abs(e.clientY - drag.y);
        if (dx < 6 && dy < 6) return;
        if (dy > dx) { drag = null; return; } /* vertical swipe: let the page scroll */
        begin(e);
      }
      if (e.cancelable) e.preventDefault();
      moveTo(pct(e.clientX) - drag.offset, 0.38);
    });

    root.addEventListener('pointerup', finish);
    root.addEventListener('pointercancel', finish);
    root.addEventListener('lostpointercapture', finish);

    if (knob) {
      knob.addEventListener('keydown', function (e) {
        var step = e.shiftKey ? 10 : 5, n = null;
        switch (e.key) {
          case 'ArrowLeft': case 'ArrowDown': n = target - step; break;
          case 'ArrowRight': case 'ArrowUp': n = target + step; break;
          case 'PageDown': n = target - 20; break;
          case 'PageUp': n = target + 20; break;
          case 'Home': n = 0; break;
          case 'End': n = 100; break;
        }
        if (n === null) return;
        e.preventDefault();
        used = true;
        moveTo(n, 0.25);
      });
    }

    /* one gentle nudge the first time it scrolls into view, so it reads as draggable */
    if (!reduce && 'IntersectionObserver' in window) {
      var hint = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        hint.disconnect();
        setTimeout(function () {
          if (used) return;
          moveTo(start - 8, 0.1);
          setTimeout(function () { if (!used) moveTo(start, 0.1); }, 700);
        }, 400);
      }, { threshold: 0.6 });
      hint.observe(root);
    }

    paint();
  }

  function init(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-gdh-ba]'), bind);
  }

  window.gdhCompare = init;
  try { init(document); } catch (err) { if (window.console) console.warn('[gd-compare]', err); }

  document.addEventListener('shopify:section:load', function (e) {
    try { init(e.target); } catch (err) {}
  });
})();
